<template>
  <div class="recruitment-contact-editor mb-4">
    <div class="d-flex align-center justify-space-between mb-3">
      <strong>{{ $t("recruitment.requirementDrawer.contactNumber", { number: index + 1 }) }}</strong>
      <v-btn icon size="x-small" variant="text" @click="$emit('remove')">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
    </div>
    <div class="recruitment-contact-editor__grid">
      <v-text-field
        :model-value="modelValue.first_name"
        :label="$t('recruitment.requirementDrawer.firstName')"
        density="compact"
        @update:model-value="updateField('first_name', $event)"
      />
      <v-text-field
        :model-value="modelValue.last_name"
        :label="$t('recruitment.requirementDrawer.lastName')"
        density="compact"
        @update:model-value="updateField('last_name', $event)"
      />
      <v-text-field
        :model-value="modelValue.email_primary"
        :label="$t('recruitment.requirementDrawer.email')"
        type="email"
        density="compact"
        @update:model-value="updateField('email_primary', $event)"
      />
      <v-text-field
        :model-value="modelValue.position"
        :label="$t('recruitment.requirementDrawer.jobTitle')"
        density="compact"
        @update:model-value="updateField('position', $event)"
      />
      <v-text-field
        :model-value="modelValue.phone_primary"
        :label="$t('recruitment.requirementDrawer.phone')"
        density="compact"
        @update:model-value="updateField('phone_primary', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "RecruitmentContactEditor",
  props: {
    modelValue: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  emits: ["update:modelValue", "remove"],
  methods: {
    updateField(field, value) {
      this.$emit("update:modelValue", { ...this.modelValue, [field]: value });
    },
  },
};
</script>

<style scoped>
.recruitment-contact-editor {
  background: rgba(var(--v-theme-on-surface), 0.02);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.1);
  border-radius: var(--app-radius-base);
  padding: 16px;
}

.recruitment-contact-editor__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.recruitment-contact-editor__grid > :nth-child(3) {
  grid-column: 1 / -1;
}

@media (max-width: 600px) {
  .recruitment-contact-editor__grid {
    grid-template-columns: 1fr;
  }

  .recruitment-contact-editor__grid > :nth-child(3) {
    grid-column: auto;
  }
}
</style>
